var $ =jQuery.noConflict();

$(function() {

	
// ------------------------------------------------------------------- [ GLOBAL VARIABLES ]
// ----------------------------------------------------------------------------------------

	var hitBottom  = false,
		hitFooterTop = false,
		photoStoryMinH = 90,
		headerH = 145,
		footerH = 56,
		globalSpeed = .5,
		hitHeaderTop = false,
		page = "home",
		winW = $(window).width(),
		winH = $(window).height(),
		storePage = "products",
		products = $('#product-grid')[0],
		currentStory = 'morning',
		foundwellLogo = $("#foundwell-loader"),
		wrapper = $("#wrapper"),
		footer = $('footer'),
		dummy = $('.dummy'),
		header = $('header'),
		blacktint = $('.black-tint'),
		blacktintintro = $('.black-tint-intro'),
		topsection = $('#top-section'),
		easeOut = Linear.easeNone,
		easeNone = Linear.easeNone,
		pinEnabled = true,
		introFinished = false,
		topSectionHidden = false,
		footerOpen = false,
		deck, 
		timer,
		slideshowInt,
		zebra = [],
		points = [],
		totalStories = $('.top-story').length,
		currtopSectionStory = "morning",
		footerTween,
		introAnimation = new TimelineLite(),
		introDone = false,
		scrollbarWidth = $.scrollbarWidth();

	var stories = ['morning', 'noon', 'evening', 'night'];
	
		//autoAlpha
	TweenLite.set("#photo-story h2", {css:{autoAlpha: 0}});
	TweenLite.set("#search-bg", {css:{autoAlpha: 0}});
	TweenLite.set("#photo-story h5", {css:{autoAlpha: 0, top:$(window).height()/2 + $("#photo-story h2").outerHeight()/2}});
	TweenLite.set(['.black-tint', '#top-section hr', 'h1.out', '.search-open', '#store-shopping-bag'], {autoAlpha:0});
	//TweenMax.set([$('.out'), $('#just-added'), $('.scene-block'), $('#top-section hr'), blacktint, $('#store-nav-container')], {css:{autoAlpha: 0}});
	$('#just-added').hide();
	$('#search-results-nav').hide();
	TweenLite.set(footer, {y:0});
	TweenLite.set('#photo-stories', {css:{autoAlpha: 0}});

		//height
	dummy.css('height', $(window).height() - headerH);
	$('#top-section').css('height', $(window).height());
	footer.css('height', $(window).height() - headerH - photoStoryMinH + 10);
	/*foundwellLogo.css("height", $(window).height()-headerH - 40).css("margin-top", 20);*/
	$('.story-block').css('height', $(window).height());

	//$(".scene-block").css("top", $(window).height()/2 - $(".scene-block").height() + 60);
	TweenLite.set(footer, {css:{top:$(window).height()-40}} );


    	//top section points
	$('.top-story').each(function(index){
		
		points.push( {point: $(window).width() / (index + 1), 
					  width: $(window).width()/totalStories,
					  xPos: index * $(window).width()/totalStories} )

		
	});

	//height	//photostories
	$('.pin-container').css('height', $(window).height() * 4).css('width', winW - scrollbarWidth);
    $('.bg-img').css('height', $(window).height()).css('width', winW - scrollbarWidth);
    $('.pin').css('height', $(window).height());

    $('.main-wrapper').css('height', $(window).height());

    $('.first-pin-container').css('height', $(window).height());
    $('.last-pin-container').css('height', $(window).height() * 2);
  

// ------------------------------------------------------------------- [ LISTENERS ]
// ---------------------------------------------------------------------------------


// ---------------------------- [ CLICK ]
// --------------------------------------
	footer.on("click", 'nav a', footerNavClick);
	header.on("click", 'h1', headerClick);
	$('.close-photo-story').on("click", closePhotoStory);
	$('#story-nav').on('click', 'a', switchStory);
	$('#share_share').on('click', toggleShareLinks);
	$('#toggle-menu').on('click', toggleMobileMenu);
	$('#toggle-story-menu').on('click', toggleStoryMenu);
	$('.search-open').on("click touchend", showSearch);
  	$('.search-close').on("click touchend", closeSearch);
    //$('.search-close').on("click", closeSearch);
	

// ---------------------------- [ MOUSEOVER/MOUSEOUT ]
// ---------------------------------------------------
	//topsection.on('mouseover', blackTintOver).on('mouseout', blackTintOut);
	topsection.on('mousemove', topSectionMouseMove);
	$('.search-open').on("mouseover", overSearchPreview).on("mouseout", outSearchPreview);


// ---------------------------- [ MOUSEWHEEL/MOUSEMOVE ]
// -----------------------------------------------------
	$('#wrapper').bind('mousewheel', mouseWheel);
	$('#footer-section').bind('mousewheel', footerWheel);
	$('.main-wrapper').bind('mousewheel', storyWheel);
	$('#photo-stories').find('.mobile').bind('mousewheel scroll', mobile_storyWheel);
	$(window).on('resize', resize);

// ---------------------------- [ MOUSEOVER/MOUSEOUT ]
// ---------------------------------------------------
	$(".archive-template div").bind("mouseover",  archiveProductsOver).bind('click', archiveProductsOver);
	$(".archive-template div, .archive-template span").bind("mouseout", archiveProductsOut);
	$('header .foundwell-header').bind('mouseover', headerOver).bind('mouseout', headerOut);



	$(window).on('resize', resize);


// ------------------------------------------------------------------- [ GETTERS/SETTERS & HELPER FUNCTIONS ]
// ----------------------------------------------------------------------------------------------------------

function setPage(p){ page = p; $('#page').text(''); }
function getPage(p){ return page; }
function disableContainerMousewheel(){ wrapper.unbind('mousewheel scroll', mouseWheel); }
function enableContainerMousewheel(){ disableContainerMousewheel(); wrapper.bind('mousewheel', { mousewheel: { behavior: 'debounce', delay: 1000 } }, mouseWheel); }


// ---------------------------- [ MOUSEWHEEL ]
// -------------------------------------------

	var topHeight = 0;
	var topTimer; 
	var footerHeight = 0;
	var btmHeight = 0;
	var btmTimer;
	var footerTimer;
	var speed = .2;
	var footerListener = 0;
	var footerTrigger = false;
	var footerWheel = 0;

	function mouseWheel(e){
		
		var scroll = $('#wrapper').scrollTop();
		var wh     = $('#wrapper').height()
		var bottom = $('#wrapper').get(0).scrollHeight;

		var dy = e.deltaY ? e.deltaY : 0;

		
		switch (page) {

			case "home":

				console.log('home scrolling')

				

				if(scroll > 0) {
		        	TweenLite.set(blacktint, {css:{autoAlpha: (scroll)/($(window).height())}});
		        	TweenLite.to("#photo-story h5", 0, {css:{autoAlpha: 1 - (scroll)/($(window).height()/5)}});
		        } else {
		        	TweenLite.set(blacktint, {css:{autoAlpha: 0}});
		        }

		        console.log('home scrolling 2')

		        //$('header h1').unbind('mouseover');

		        var mult = scroll < winH/2 ? 0 : (scroll-(winH/2));
		        //console.log(mult);
		       	var diff = winW/winH + scroll/winW;

		       	var title_scroll = (mult * diff)*2;
		       	var title_width = winW - 100 - scrollbarWidth - title_scroll;
	
		       

				if(header.offset().top + dy <= 40) {

					console.log('home scrolling 3')
					
					dummy.css('height', 40);
					header.css('width', winW-scrollbarWidth).css('top', 40);
			
					$("#photo-story h2").css('left', 0);
					$("#store").css('top', 0);
					$(topsection).css('height', 40);

					//$('#a-day-observed-container').css('height', 90).css('width', 271).css('left', winW/2 - $('#a-day-observed-container').width()/2)



					if($('#store-shopping-bag').css('visibility') == 'hidden') {
						TweenLite.to(['.search-open', '#store-shopping-bag'], .4, {autoAlpha:1});	
					}
					

					//TweenLite.set($('#a-day-observed-container'), {height:$(window).height() - (scroll + headerH), marginLeft:40 + scroll, marginRight:40 + scroll});
		        	//textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:3000, minFontSize:24, multiLine: false});

					$('#top-section').addClass('fixed');
					$('#top-section').css('width', winW - scrollbarWidth);

					header.addClass('fixed');
					$('#wrapper').addClass('fix-fixed');

					topsection.on('mouseover', blackTintOver).on('mouseout', blackTintOut);
					
					var animation = new TimelineLite()
					animation.to(wrapper, 0, {scrollTo: {y: 0}} )
							 .to($('#store-nav-container'), globalSpeed, {autoAlpha: 1, delay:globalSpeed} )

					$("#wrapper").animate({ scrollTop: 0, ease:'linear' }, 0, 'linear');
					TweenLite.to(blacktint, speed, {autoAlpha:1});			

					wrapper.disablescroll();
					setPage('store');
				}



				if($('body').attr('id')=='archive'){
					if($(dummy).height() < winH - 200){
						TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
        				TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
					} else {
						TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
        				TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
					}
				}

			break;

			case "store":
				
				//$('header h1').bind('mouseover', headerOver);
				setTimeout(function(){ wrapper.disablescroll('undo'); }, 300);
				$('footer').css('pointer-events', 'auto');

				if(winW > 768) {
					if($('#drawer').css('display') != 'none') {
						$('.toggle-drawer').trigger('click'); 
						$('#store-shopping-bag').removeClass('active');
					}
				}

	    		if($("#wrapper").scrollTop() <= 0 && e.deltaY > 1) {
	    			topSectionHidden = false;
		    		var diff;

		    		// tension control for more of a natural feel
					if(topHeight >=10) {

						diff = 2;
					} else if(topHeight >=20) {
				
						diff = 3;
					} else if(topHeight >=50) {
				
						diff = 4;
					} else {
				
						diff = 5;
					}
		  
		    		
	    			
		    		if(topHeight < 37) {
		    			//TweenLite.to($('p'), .1, {height:40 + height})
		    			TweenLite.to($('#store'),  speed, {y:topHeight});
	    				TweenLite.to(header,  speed, {y:topHeight});
		    			TweenLite.to(topsection,  speed, {height:40 + topHeight});
	    				TweenLite.to(blacktint, speed, {autoAlpha:.63 - (topHeight/100) });			
	    				//$('#wrapper').scrollTop(1);
		    			
		    			
		    			topHeight += diff;
		    		} else {
		    			topHeight = 37; 
		    			//console.log(topHeight)
		    			TweenLite.to($('#store'),  speed, {y:40});
	    				TweenLite.to(header,  speed, {y:40});
		    			TweenLite.to(topsection,  speed, {height:40 + topHeight});
	    				TweenLite.to(blacktint, speed, {autoAlpha:.26});
		    
		    			//$('#wrapper').unbind('mousewheel scroll');
		    			disableContainerMousewheel();
		    		}

		    		
		    		topTimer = setTimeout(function() {
		    			topHeight = 37; 
		    			//$('#wrapper').unbind('mousewheel scroll');
		    			disableContainerMousewheel();

			  			TweenLite.to(topsection, .4, {height:40, delay:.05, onComplete:function(){
			  				//$('#wrapper').bind('mousewheel scroll', mouseWheel);
			  				enableContainerMousewheel();
			  				topHeight = 0;
			  			}});

			  			TweenLite.to($('#store'), .4, {y:0, delay:.05});
	    				TweenLite.to(header,  .4, {y:0, delay:.05});
	
	    				TweenLite.to(blacktint,  .4, {autoAlpha:1, delay:.05, overwrite:'all' });
	    				topHeight = 0;

					}, 100);
		    		
			  	} else {

			  		topSectionHidden = true;

					TweenMax.to(dummy, .2, {height:40, ease:easeOut});
					TweenMax.to(topsection, .2, {height:40, ease:easeOut});
					TweenMax.to(blacktint, .2, {autoAlpha:1, ease:easeOut});
					TweenMax.to(header, .2, {css:{top:40}, ease:easeOut});	
			  	}


					
			break;

			case "footer":
					/*
					if(!footerOpen && 
						hitFooterTop && 
						footer.position().top >= 149 && 
						e.deltaY > 1 && 
						footer.position().top + e.deltaY <= $(window).height() - footerH) {

						/*
						console.log('footer wheel ')
						
						
						$('#footer-section').disablescroll();
						$('#wrapper').disablescroll();
						e.preventDefault();
						TweenMax.to(footer, 0, {css:{top:footer.position().top + e.deltaY}});
						
					} else if(footer.position().top + e.deltaY >= $(window).height() - footerH) {
						//TweenMax.to(footer, 0, {css:{top:$(window).height() - 40}});
						
						/*TweenLite.to($('#store-nav-container'), globalSpeed, {autoAlpha: 1} );
						setPage('store');
						TweenMax.to(footer, globalSpeed, {css:{top:$(window).height()- footerH}});
						$('footer').css('pointer-events', 'auto')
						TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:1});
						wrapper.disablescroll();
					}
					*/
					//TweenMax.to(footer, 0, {css:{top:footer.position().top + e.deltaY}});
					e.preventDefault();
					if(footer.position().top + e.deltaY <= $(window).height() - 56 &&
					   footer.position().top + e.deltaY > headerH){
						$('#wrapper').disablescroll();
						footer.css('top', footer.position().top + e.deltaY);
						TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:1});
						$('footer .footer-nav').removeClass('active');
						if($('body').attr('id') == "archive")
							TweenLite.to(["header", '#store'], globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
			
					} else if(footer.position().top + e.deltaY <= headerH){
						footer.css('top', headerH).css('pointer-events', 'auto');
						setPage('footer');
						TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#fafafa", ease:easeOut,});
						$('#footer-section').disablescroll('undo');
						TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:0});
					} else if(footer.position().top + e.deltaY >= $(window).height() - 56) {
						setPage('store');
						$('footer').css('pointer-events', 'auto');
						footer.css('top', $(window).height()- 56);
						TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:1});
						//	wrapper.disablescroll();
					
					}
					//$('header h1').bind('mouseover', headerOver);
			break;

		} // end switch

		hitBottom = false;


		//FOOTER
 		//console.log(e.deltaY)
		if(scroll + wh >= bottom) { // scrolled bottom of page

			if(!hitBottom && e.deltaY < -10) {

				$(footer).disablescroll();


				var diff;

		    		// tension control for more of a natural feel
					if(btmHeight >=10) {

						diff = 2;
					} else if(btmHeight >=20) {
				
						diff = 3;
					} else if(btmHeight >=50) {
				
						diff = 4;
					} else {
				
						diff = 5;
					}
	    			
		    		if(btmHeight < 20) {
		    			TweenLite.to(footer, .4, {y:-btmHeight});
		    			btmHeight += diff;

		    		} else {
		    			btmHeight = 20; 
		    			TweenLite.to(footer, .4, {y:-btmHeight});
		    			//$('#wrapper').unbind('mousewheel scroll');
	
		    			
		    		}

		    		footerTimer = setTimeout(function(){ footerTrigger = true; }, 500);

		    		//console.log('hit bottom ' + footerTrigger)
		    		//hitBottom = true;
		    		clearTimeout(btmTimer);

		    		//$(wrapper).scrollTop(bottom - 1)
		    		//clearTimeout(footerTimer);
		    		if(footerTrigger) {
		    			
		    			hitBottom = true;
		    			

		    		}
		    		
		    		btmTimer = setTimeout(function() {
		    			footerTrigger = false;
		    			clearTimeout(footerTimer);
		    			//$('#wrapper').unbind('mousewheel scroll');
		    			btmHeight = 0; 
		    			lastScroll = 0;

		    			TweenLite.to(footer, .4, {y:0, onComplete:function(){
		    				//$('#wrapper').bind('mousewheel scroll', mouseWheel);
		    				enableContainerMousewheel();
		    				btmHeight = 0; 
		    				hitBottom = false;
		    				footerTrigger = false;

		    			}});

					}, 100);

			} else {
				if(getPage()!='footer' && e.deltaY > 1 ) {
					$('footer').css('pointer-events', 'auto');
					hitBottom = false;
					TweenLite.to(footer, .4, {y:0});
					TweenLite.to(footer, .4, {css:{top:$(window).height()-56}});
					footerWheel = 0;
				}
			}




			if (!footerOpen && hitBottom) { // scroll up footer manually
				footerListener = 0; 
				TweenMax.to(footer, 0, {y:0});
				
				TweenLite.killTweensOf(footer);
				$('#wrapper').disablescroll();
				
				
				if((footer.offset().top + e.deltaY) >= headerH  && (footer.offset().top + e.deltaY) <= $(window).height()-56) {
					
					footerWheel = e.deltaY/e.deltaFactor;
					setPage('footer');
					e.preventDefault();
					$('#footer-section').disablescroll();

					$('footer').css('pointer-events', 'none');
					TweenMax.to(footer, 0, {css:{top:footer.position().top + footerWheel}});
				} else if((footer.offset().top + e.deltaY) >= $(window).height()-56) {
					footerWheel = 0;
					setPage('store');
					TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:1});
				} else {
						console.log('SET BG COLOR')
					if($('body').attr('id') != 'archive'){
						TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#fafafa", ease:easeOut});
					} else {
						TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut});
					}
						
						TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:0});
						topSectionHidden = false;
						//TweenLite.to(wrapper, .2, {scrollTo: {y: 0, ease:easeOut, delay:globalSpeed}} );
						
						TweenLite.to(topsection, .2, {height:40, ease:easeOut});
						TweenLite.to(header, .2, {css:{top:40}, ease:easeOut});
						TweenLite.to(dummy, .2, {height:40, ease:easeOut, onComplete:function(){

							if(!header.hasClass('fixed')){
								TweenMax.to(topsection, 0, {height:40});
								$('#top-section').addClass('fixed');
								$('#top-section').css('width', winW - scrollbarWidth);
								header.addClass('fixed');
								$('#wrapper').addClass('fix-fixed');
							}

						}});

						$('footer').css('pointer-events', 'auto').css('top', headerH);
						footerOpen = true;

						$('#wrapper').disablescroll();
						$('#footer-section').css('overflow-y', 'scroll');
						setTimeout(function() { $('#footer-section').disablescroll('undo'); }, 100);

						//if(winW < 768)
						//TweenLite.to($('#wrapper'), globalSpeed/2, {scrollTo: {y: 0, ease:easeOut}} );

						
						TweenLite.to($('#store-nav-container'), globalSpeed, {autoAlpha: 0} );
						


					
						setPage('footer');
					
				}
				
			} 
		}


		if($('#drawer').css('display') == 'block') {
			//$('#drawer').hide();
		}

		if(e.deltaY > 1 && getPage()!='footer') {
			$('#footer-section').disablescroll();
			//TweenMax.to(footer, globalSpeed, {css:{top:$(window).height()-40}});
		}	

	} // end mouseWheel

	function mobile_storyWheel(e){
		e.stopPropagation();

		var container = $('#photo-stories').find('.mobile-scroller');
		//console.log(container.scrollTop())
		var credit = $('#photo-stories').find('.mobile-scroller').find('p');
		var last = $('#mobile-a-day-observed-night').find('.slide').last();
		var scrollheight = $(container)[0].scrollHeight;
		var startfadein = scrollheight - (winH) - 140
		var opacity = 1;



		if(container.scrollTop() < startfadein) {
			opacity =  0;
			
		} else {  
			opacity = (container.scrollTop() - startfadein) / 100;
		}

		
		TweenLite.set($(credit), {css:{autoAlpha: opacity }});
	}

	function storyWheel(e){
		var scroll = $('.main-wrapper').scrollTop();
		var value = 1- (scroll)/($(window).height()/2);
		var value_2 = 1- (scroll)/($(window).height()/4);
		if(value < 0) value = 0;
		if(value_2 < 0) value_2 = 0;
		TweenLite.set($('#pin-init p'), {css:{autoAlpha: value }});
		TweenLite.set($('#pin-init a'), {css:{autoAlpha: value_2 }});
	}

	$('#drawer').on('mousewheel', function(e){
		e.stopPropagation();

	});


	var footerWheelListener = 0;
	hitFooterTop = false;
	clearTimeoutHitFootertop = null; 
	function footerWheel(e){
		

		// 1. create mock scroller the height of the footer section 
		// 2. add a fixed header to <footer>
		// 3. scrolls underneath the header
		// 4. when footer nav reaches bottom remove mock scroller


		$('section').each(function(i){
			if($('#footer-section').scrollTop() > ($('section').eq(i).position().top - 36) &&
			   $('#footer-section').scrollTop() < $('section').eq(i).position().top + $('section').eq(i).height()) {
				var id = $('section').eq(i).attr('id').split('footer-').join('')
				$('footer .footer-nav').removeClass('active');
				$('footer').find('.footer-' + id).addClass('active');
              $('footer').attr('active', 'true');

			}
		})

		hitBottom = false;
		if(getPage()!="footer") {
			e.preventDefault();
		} else {
			if($('#footer-section').scrollTop()==0 && e.deltaY > 1) {
				//console.log('footer wheel')
				footerOpen = false;
				if(!hitFooterTop){
					//console.log('hit footer top ')
					//clearTimeout(clearTimeoutHitFootertop);
					clearTimeoutHitFootertop = setTimeout(function(){ hitFooterTop = true;  }, 100);
				} else {
					hitFooterTop = true;
					//console.log('hit footer top is true')
					footerOpen = false;
					//$('#wrapper').disablescroll();
					footerWheelListener += e.deltaFactor;
					if(footerWheelListener > 5) {
						
						//enableContainerMousewheel();
						$('footer').css('pointer-events', 'none')
						//$('#footer-section').disablescroll();
						//$('#wrapper').disablescroll('undo');
						//setPage('store');
					}
					clearTimeout($.data(this, 'timer'));
			  		$.data(this, 'timer', setTimeout(function() {
				     	//hitFooterTop = false;
				     	footerWheelListener = 0;
				  	}, 200));
				}
			} else {
				clearTimeout(clearTimeoutHitFootertop);
              	$('footer').attr('active', 'false');

				//hitFooterTop = false;
			}
		}
	}


	$('#wrapper').bind("mobileinit", function(){
  		$.mobile.touchOverflowEnabled = true;
	});

	$('html').click(function() {
		if($('#drawer').css('display') != 'none') {
			$('.toggle-drawer').trigger('click'); 
			$('#store-shopping-bag').removeClass('active');
		}
	});

	$('#drawer').click(function(event){
	    event.stopPropagation();
	});


// Crossfade the top section images as you move the cursor from right to left

	function topSectionMouseMove(e) {
		
		//console.log($('#a-day-observed-container h2').offset().top);

		if(e.pageY < $('#a-day-observed-container h2').offset().top || e.pageY > $('#a-day-observed-container h2').height() + $('#a-day-observed-container h2').offset().top ) {
			$('body').css('cursor', 'auto');
			$(e.currentTarget).css('cursor', 'auto');
			$('#a-day-observed-container h2').html('A Day Observed');
			$('#a-day-observed-container h2').removeClass('over');
			$('.subtext').show();
		} else {
			$('body').css('cursor', 'pointer');
			$(e.currentTarget).css('cursor', 'pointer');
			$('#a-day-observed-container h2').html('&#40;<span class="over">Enter</span>&#41;');
			$('.subtext').hide();
		}

		/*

		mx = e.clientX;
		var lastStory = currtopSectionStory;

		$('.top-story').each(function(index){

			var pt = $(window).width() - points[index].point;
			var w = points[index].width;
			var x = points[index].xPos;


			if(mx >= (x) && mx <= (x + w)) {
				TweenLite.to($(this), .3, {autoAlpha:1, overwrite:true});
				$('.scene-num').text('Scene ' + (index+1) + ':');
				$('.scene-time').text( $(this).attr('id').split('top-section-').join('') );
				currtopSectionStory = $('.scene-time').text();
			} else {
				if(index != $('.top-story').length)
	        	TweenLite.to($(this), .3, {autoAlpha:0, overwrite:true});

	        	$(this).css('z-index', $(this).css('z-index') - 1)
			}

			

		});
		*/

	}

	function nextStory(e){

		e.preventDefault();
		//window.scroll(0, 1)
		nextStory = $(e.currentTarget).attr('href').split('#').join('');
		//console.log('#story-nav ' + '#' + nextStory + '-nav')
		$('#story-nav ' + '#' + nextStory + '-nav').trigger('click');

	}

	function switchStory(e){

		e.preventDefault();

		var link   = $(e.currentTarget).attr("href");

		window.location = link;
		TweenLite.to($('.main-wrapper'), 0, { scrollTo:0 });
		var offset = $(link).find('div').offset().top;
		var pinH   = $('.pin-container').height() * 3;
		//var dist   = $(e.currentTarget).index() * pinH

		TweenLite.to($('.main-wrapper'), 0, { scrollTo:offset });
		$('#story-nav a').removeClass('active');
		$(e.currentTarget).addClass('active');
		
	}

	function toggleShareLinks(e){
		e.preventDefault();
		$('#share').toggle();
		//$('#wrapper').scrollTo($('#wrapper').get(0).scrollHeight);
		TweenLite.to($('#wrapper'), 1, { scrollTo:$('#wrapper').get(0).scrollHeight + 300 });
	}

	function toggleMobileMenu(e){
		e.preventDefault();
		if($('#main-menu').css('display')=='none'){
			TweenLite.to('#store', 0, { y:$('#main-menu').outerHeight() + 30 });
			TweenLite.to('header', 0, { height:300 });
			$('#main-menu').slideDown(00);
			
			//console.log('show menu')
		} else {
			//console.log('hide menu');
			TweenLite.to('#store', 0, { y:0 , delay:.0});
			TweenLite.to('header', 0, { height:141 , delay:.0 });
			$('#main-menu').slideUp(00);
			
		}

	}

	function toggleStoryMenu(e){
		e.preventDefault();
		if($('#story-nav').css('display')=='none'){
			$('#story-nav').slideDown(200);

			$('.toggle-menu-bg').show();
			
			$('#toggle-story-menu').css('z-index', '9999');
			$('.toggle-menu-bg').css('z-index', '9999');
			$('#story-nav').css('z-index', '9999');
			//console.log('show menu')
		} else {
			//console.log('hide menu'); 
			$('#story-nav').slideUp(200);
			$('.toggle-menu-bg').hide();
			$('#toggle-story-menu').css('z-index', '9');
			$('.toggle-menu-bg').css('z-index', '8');
			$('#story-nav').css('z-index', '9');
		}

	}

	function closePhotoStory(){
		setTimeout(function(){
			//topsection.on('click', topSectionClick);
			//blacktint.on('click', topSectionClick);
			//$("#top-section").on('click', topSectionClick);
		}, 1000);

		headerOut();
		

		TweenLite.to($('.top-story').parent(), globalSpeed/2, {autoAlpha: 1, ease:easeOut});

		$('#photo-stories').removeClass('open');
		TweenLite.set(["#a-day-observed-container", ".subtext"],{autoAlpha:1});

		$("#a-day-observed-container").fadeOut(0);
		$("#a-day-observed-container").fadeIn(globalSpeed/2 * 1000);
		$(".subtext").fadeOut(0);
		$(".subtext").fadeIn(globalSpeed/2 * 1000);
		
		setPage('home');
		$(wrapper).disablescroll('undo');
		//$('#wrapper').bind('mousewheel scroll', mouseWheel);
		enableContainerMousewheel();
		TweenLite.to($('.top-story'), globalSpeed/2, {height: $(window).height() - headerH, ease:easeOut} ); 
		TweenLite.to($('.parallax-scroller'), globalSpeed/2, {autoAlpha:0});
		//TweenLite.to($('.main-wrapper'), globalSpeed/2, {autoAlpha:0});
		TweenLite.to($('#photo-stories'), globalSpeed/2, {autoAlpha: 0, delay:globalSpeed/2} );
		TweenLite.to($('.close-photo-story'), 1, {autoAlpha:0});
		TweenLite.to($('.close-photo-story'), 0, {css: {right: -100}, delay:globalSpeed/2} );
		
		if(winW > 768)
		TweenLite.to(dummy, globalSpeed/2, {height: $(window).height() - headerH - 20, ease:easeOut} );
		else
		TweenLite.to(dummy, globalSpeed/2, {height: $(window).height() - headerH - 20, ease:easeOut} );
		TweenLite.to(footer, globalSpeed/2, {css:{top:$(window).height()-footerH}, ease:easeOut} );
		
		TweenLite.to(topsection, globalSpeed/2, {height: $(window).height() - headerH, ease:easeOut, delay:globalSpeed/2, onComplete:function(){
			setTimeout(function(){ $('header h1').trigger('click'); }, 500);
			//console.log('open store')
		}} );
		//TweenLite.to($(".scene-block"), globalSpeed/2, {css:{top: $(window).height()/2 - $(".scene-block").height()/2 - 30}, delay:globalSpeed/2, ease:easeOut} );
	}


	

	function showPhotoStory() {
		$('#photo-stories').show();
		//dummy.off('click touchend', topSectionClick);

		topsection.off('mouseover', blackTintOver).off('mouseout', blackTintOut);
		//$("#top-section").off('click touchend', topSectionClick);

		$('#photo-stories').addClass('open');

		TweenLite.to("#a-day-observed-container", globalSpeed/2, {autoAlpha:0, onComplete:function(){
			$('.subtext').show();
			$('#a-day-observed-container h2').text('A DAY OBSERVED').removeClass('active');
		}});
		
		
		

		TweenLite.to($('.top-story').parent(), globalSpeed/2, {autoAlpha: 0, ease:easeOut, onComplete:function(){


			//TweenLite.set($('#morning'), {autoAlpha:0});
			TweenLite.set($('.main-wrapper'), {autoAlpha:0});

			//currtopSectionStory = 'morning';
			//setTimeout(function(){ $('#'+currtopSectionStory+'-nav').trigger('click'); }, 0);

		
			TweenLite.to($('.parallax-scroller'), globalSpeed/2, {autoAlpha:1});

			TweenLite.to(".subtext", 0, {autoAlpha:0});

			setPage('photostory');
			//wrapper.unbind('mousewheel', mouseWheel);
			disableContainerMousewheel();
			wrapper.disablescroll();
			//$('#photo-stories').show();
			TweenLite.to(dummy, globalSpeed/2, {height: $(window).height(), ease:easeOut} );
			TweenLite.to(footer, globalSpeed/2, {css:{top:$(window).height()}, ease:easeOut} );

			TweenLite.to(topsection, 0, {height: $(window).height(), ease:easeOut} );
			TweenLite.to(wrapper, globalSpeed/2, {scrollTo: 0, ease:easeOut} );

			//TweenLite.to($('.parallax-scroller'), 0, {scrollTo: 1, ease:easeOut} );

			$('.parallax-scroller').find('.bg').css('opacity', 0);
			$('.parallax-scroller').scrollTop( 0 );

			TweenLite.to($('#photo-stories').find('.mobile'), 0, {scrollTo: 1, ease:easeOut} );
			$('.parallax-scroller').trigger('mousewheel');

			pauseSlideShow();
			

			//TweenLite.to($(".scene-block"), globalSpeed/2, {css:{top: $(window).height()/2 - $(".scene-block").height()/2}, ease:easeOut} );

			TweenLite.set($('#story-nav'), {autoAlpha: 0} );
			TweenLite.to($('#story-nav'), globalSpeed/2, {autoAlpha: 1, delay:globalSpeed} );

			TweenLite.to($('#photo-stories'), globalSpeed/2, {autoAlpha: 1, delay:globalSpeed/2} );
			TweenLite.to($('.main-wrapper'), globalSpeed/2, {autoAlpha: 1, delay:globalSpeed} );

			TweenLite.to($('.close-photo-story'), 0, {autoAlpha:1});

			if(winW >600)
				TweenLite.to($('.close-photo-story'), globalSpeed/2, {css: {right: 30}, delay:1} );
		 	else
		 		TweenLite.to($('.close-photo-story'), globalSpeed/2, {css: {right: 30}, delay:1} );
			
			//$('#photo-stories').fadeIn();
			//TweenLite.to($('#photo-stories'), globalSpeed, {autoAlpha: 1, force3D:true});
			setPage('photostory')
		}} );

		
	}

	var showStoreInt = false;
	function showStore(){
 		
 		if(!showStoreInt){
 			showStoreInt = true;
 			setTimeout(function(){ showStoreInt = false}, 1000);
			pauseSlideShow();

	 		introAnimation.progress(1, false);
	 		disableContainerMousewheel();
	 		//$('#wrapper').unbind('mousewheel scroll');
	 		dummy.off('mouseover', blackTintOver).off('mouseout', blackTintOut);
	 		headerOut();

			footerOpen = false;
			hitFooterTop = false;
			hitBottom = false;
			topSectionHidden = false;
			
			TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:1});

			if($('body').attr('id') == "archive"){
				TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
	        	TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
	    	}

			$('.footer-nav').removeClass('active');
			$('footer').css('pointer-events', 'auto')

			if(dummy.height() > 40) {

			
				//TweenLite.to($('#a-day-observed-container'), .1, {height:winH/2, onUpdate:function(){  textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:3000, minFontSize:18, multiLine: false}); }});
				//TweenLite.to($('#a-day-observed-container'), .2, {delay:.1, height:40, width:271, left:(winW/2) - 135, onUpdate:function(){  textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:3000, minFontSize:18, multiLine: false}); }});

				TweenLite.to(blacktint, globalSpeed/2, {autoAlpha: 1});
				
				$("#wrapper").animate({ scrollTop: 0}, globalSpeed/2 * 1000);

				TweenLite.to(header, 0, {css:{top:0}} );
				TweenLite.killTweensOf(dummy);
				TweenLite.to(dummy, globalSpeed/2, {height:40, ease:easeOut, overwrite:'all', onComplete:function(){

				
			   

					enableContainerMousewheel();
					//$('#wrapper').bind('mousewheel scroll', mouseWheel);
					setPage("store");
					history.pushState(null, null, '#store');

					if(!header.hasClass('fixed')){
						TweenLite.to(header, 0, {css:{top:40}} );
						TweenMax.to(topsection, 0, {height:40});
						$('#top-section').addClass('fixed');
						$('#top-section').css('width', winW - scrollbarWidth);
						header.addClass('fixed');
						$('#wrapper').addClass('fix-fixed');
						header.css('width', winW-scrollbarWidth)
					}

				}} );
			
			} else {

			}



			setTimeout(function(){ 
				topsection.on('mouseover', blackTintOver).on('mouseout', blackTintOut); 
				setPage("store"); 
				wrapper.disablescroll('undo'); 
				enableContainerMousewheel(); 
				//$('#wrapper').bind('mousewheel scroll', mouseWheel); 
			}, globalSpeed/2 * 1000);
			
		
			TweenLite.to(footer, globalSpeed/2, {css:{top: $(window).height() - footerH}, force3D:true, ease:easeOut});
			

			//hideJustAdded();
			headerOut();
			TweenLite.to($('#store-nav-container'), globalSpeed, {autoAlpha: 1} );
			TweenLite.to($("#store-cat-items"), globalSpeed, {autoAlpha: 1, force3D:true});
	        TweenLite.to($("#store-show-all"), globalSpeed, {autoAlpha: 1, force3D:true});
		
		}

	}

	/* FADE IMAGES ON LOAD
	$('.image-holder img').each(function(e){
		$(this).on('load', imgLoaded($(this)));
	});

	function imgLoaded(img){
		console.log($(img))
	    var $img = $(img);
	 	TweenLite.to($img, globalSpeed, {css:{opacity: 1}, delay:.5} );
	    //$img.parent().addClass('loaded');
	};
	*/


	function loadStore(){

		window.location = "#";
	

		//dummy.off('touchend', topSectionClick);
		//topsection.off('click touchend', topSectionClick);
		//topsection.off('touchend', topSectionClick);

		topsection.on('mouseover', blackTintOver).on('mouseout', blackTintOut);

		wrapper.disablescroll('undo');
		introAnimation.progress(1, false);
		topSectionHidden = true; 

		$('.image-holder').css('height', ($('.col-xs-6').width() / 1.5) + 5)
		dummy.css('height', 40);
		$("#photo-story h2").css('left', 0);
		$("#store").css('top', 0);
		$(topsection).css('height', 40);

		TweenLite.set(['.search-open', '#store-shopping-bag', '#photo-story h2'], {autoAlpha:1});
		
		



		header.css('width', winW-scrollbarWidth).css('top', 40);
		$('.black-tint-intro').css('display', 'none');

		TweenLite.set(blacktint, {autoAlpha: 1});

		
		//$('#a-day-observed-container').css('height', winH -  scroll - headerH).css('width', 271).css('left', winW/2 - 135);
		//$('#a-day-observed-container').find('h2').css('opacity', 1).css('visibility', 'visible');

		$('#top-section').addClass('fixed');
		$('#top-section').css('width', winW - scrollbarWidth);
		header.addClass('fixed');
		$('#wrapper').addClass('fix-fixed');
		$('#photo-story').addClass('fixed');
		$('.black-tint-intro').remove();

		foundwellLogo.remove();

		$('#product-info').html(function(i,h){
    		return h.replace(/&nbsp;/g,'');
		});

		$('#product-page-gallery h1.desktop').html( $('#product-page-gallery h1.desktop').text().replace(/"([A-Za-z ]*)"/ig, "&ldquo;$1&rdquo;") );
		$('#product-page-gallery h1.mobile').html( $('#product-page-gallery h1.mobile').text().replace(/"([A-Za-z ]*)"/ig, "&ldquo;$1&rdquo;") );

		$('h1').widowFix();
		$('#product-info').widowFix();

		
		TweenLite.to($('#store-nav-container'), globalSpeed, {autoAlpha: 1, delay:globalSpeed} )

		

		$('.col-xs-6 img').on('load', function(e){
			$(this).parent().css('height', 'auto');
		});



		//$("#wrapper").animate({ scrollTop: 0, ease:'linear' }, 400, 'linear');

		setPage('store');

	}

	var rand_image = Math.round(Math.random()*3);
	var next_image = 0;
	var curr_image = $('.top-story').eq(0);
	var slideshow_playing = false; 

	function startSlideShow(){
		if(!slideshow_playing)
		slideshowInt = setInterval(function(){
			
		//console.log('curr_image ' + curr_image.index());

			if(next_image < 3) {
				next_image++;
			} else {
				next_image = 0;
			}
			
			TweenLite.to($('.top-story').first(), globalSpeed, {autoAlpha: 0, onComplete:function(){
				//$(curr_image).removeClass('top-image');
				$('.top-story').first().appendTo($('.top-story').parent());
				//$('.top-story').eq(next_image).addClass('top-image');
				TweenLite.to($('.top-story').last(), globalSpeed, {autoAlpha: 1});
				curr_image = $('.top-story').eq(next_image);
				
			}});

		}, 3000);
	}

	function pauseSlideShow(){
		//console.log('clear interval pause slideshow')
		slideshow_playing = false;
		clearInterval(slideshowInt);
	}


	function intro(action){

		topsection.on('click touchend', topSectionClick);
		//blacktint.on('click', topSectionClick);
		//topsection.on('click', topSectionClick);
		

		dummy.bind('mousemove', topSectionMouseMove).on('click touchend', topSectionClick);
		//$(topsection).bind('mousemove', topSectionMouseMove);


		$('#wrapper').trigger('mousewheel');
		if(action == "play"){
			TweenLite.set('#photo-story h2', {autoAlpha: 0})

			introAnimation.add(TweenLite.to(['.black-tint-intro', foundwellLogo], 2, {autoAlpha: 0, delay:1, onComplete:function(){
				//console.log('-------------------[INTRO FINISHED]')
				foundwellLogo.remove();
				startSlideShow();
			}}));

			introAnimation.add(TweenLite.to('#photo-story h2', 1, {autoAlpha: 1}));
			introAnimation.add(TweenLite.to('#photo-story h5', 1, {autoAlpha: 1, onComplete:function(){ introFinished = true; }}));
		}
	}

	//console.log( $('.pin-container').eq(0) );

	$('.outer-container').eq(0).addClass('in-view');
	var currpin = 0;
	var to_next_pin = false;
	var next_y = 0;
	$('.main-wrapper').click(function(e) {

		/*

		if(!$('.outer-container').eq(currpin).hasClass('first') && !$('.outer-container').eq(currpin).hasClass('last')){
			if(!to_next_pin){
				console.log('scroll to bg')
				next_y = $('.outer-container').eq(currpin).position().top + (winH * 4);
				to_next_pin = true;
				currpin++;
			} else {
				
				currpin++;	
				console.log('scroll to next pin + ' + currpin)
				next_y = $('.outer-container').eq(currpin).position().top;
				to_next_pin = false;
			}
		} else {
			console.log('FIRST or LAST')
			
			
			console.log('scroll to next pin  + ' + currpin)
			next_y = $('.outer-container').eq(currpin).position().top;
			currpin++;
			to_next_pin = false;
		}
		console.log('CURR PIN ' + currpin)
		$('.main-wrapper').disablescroll();
		TweenLite.to($('.main-wrapper'), 3, {scrollTo: {y: next_y }, onComplete:function(){ $('.main-wrapper').disablescroll('undo');  }} );
		*/
	});

	var topSectionClickInt = false;
	function topSectionClick(e) {
		e.stopPropagation();
		//e.stopImmediatePropagation();

		if(!topSectionClickInt){
			
			topSectionClickInt = true;
			setTimeout(function(){ topSectionClickInt = false; }, 300);

			headerOut();
			//$('#wrapper').unbind('mousewheel scroll');
			disableContainerMousewheel();

			if($('#drawer').css('display') != 'none') {
				$('.toggle-drawer').trigger('click'); 
				$('#store-shopping-bag').removeClass('active');
			}

			//setTimeout(function(){ $('#wrapper').bind('mousewheel scroll', mouseWheel); }, 1000);
			hitFooterTop = false;

			closeSearch();
			$('.footer-nav').removeClass('active');
			topsection.off('mouseover', blackTintOver).off('mouseout', blackTintOut);
			//dummy.off('mouseover', blackTintOver).off('mouseout', blackTintOut);
			TweenMax.to(blacktint, globalSpeed/2, {autoAlpha:0, overwrite:'all', ease:easeOut});

			TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:0});

			//TweenLite.to("#a-day-observed-container", globalSpeed/2, {height:$(window).height() - headerH, left:50 + scrollbarWidth/2 , width: winW - 100 - scrollbarWidth, onUpdate:function(){ textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:3000, multiLine: false})} });
			$('#top-section').find('.preview').remove();
			
			switch(page){

				case "home":

					setPage('photostory')
					showPhotoStory();
					
				
				break;

				case "store":
					setPage('home');
					pauseSlideShow();
					wrapper.scrollTop(0)
					wrapper.disablescroll();

					TweenLite.set('#photo-story h2', {autoAlpha: 1})
					
					//dummy.on('click touchend', topSectionClick);
					//blacktint.on('click touchend', topSectionClick);
					topsection.off('click touchend', topSectionClick);
					topsection.off('mouseover', blackTintOver).off('mouseout', blackTintOut);

					TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
	        		TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});

					hitFooterTop = hitBottom = false;

					TweenLite.to(footer, globalSpeed/2, {css:{top:$(window).height()-footerH}, ease:easeOut});

					if(header.hasClass('fixed')) {
						$('#top-section').removeClass('fixed');
						$('header').removeClass('fixed');
						$('#wrapper').removeClass('fix-fixed');
						header.css('width', winW-scrollbarWidth)
						dummy.removeClass('fixed');
					}

					TweenLite.to(header, globalSpeed/2, {css:{top:0}} );
					
					//$('#wrapper').bind('mousewheel scroll', mousewheel);

					
					//TweenLite.to("#photo-story h5", globalSpeed/2, {css:{autoAlpha: 1 }});
					//TweenLite.set("#photo-story h5", {css:{top:$(window).height()/2 + $("#photo-story h2").outerHeight()/2}});

					TweenLite.to(topsection, globalSpeed/2, {height: $(window).height() - headerH - 20, ease:easeOut} );
					//TweenMax.to(blacktint, globalSpeed/2, {height:$(window).height() - headerH, ease:easeOut});
					TweenMax.to(dummy, globalSpeed/2, {height:$(window).height() - headerH - 20, ease:easeOut, onComplete:function(){
						dummy.css('height', $(window).height() - headerH - 20);
						enableContainerMousewheel();
						wrapper.disablescroll('undo');
						//$('#wrapper').bind('mousewheel scroll', mouseWheel);
						setPage('home');
						startSlideShow();
						topsection.on('click touchend', topSectionClick);
						history.pushState(null, null, '#home');
					}});
					TweenLite.to("#photo-story h5", globalSpeed, {autoAlpha:1});
					TweenMax.to($('#wrapper'), 0, {scrollTo:0});


					
				break;

				case "footer":
					
					$(wrapper).scrollTop(0);
					hitFooterTop = hitBottom = false;
					TweenLite.to(footer, globalSpeed/2, {css:{top:$(window).height()-footerH}, ease:easeOut, onComplete:function(){
						setPage('home');
					}});
					TweenLite.to(header, 0, {css:{top:0}, ease:easeOut});

					if(header.hasClass('fixed')) {

						$('#top-section').removeClass('fixed');
						$('header').removeClass('fixed');
						$('#wrapper').removeClass('fix-fixed');
						$('header').css('width', winW)
						dummy.removeClass('fixed');

					}

					TweenLite.to(topsection, globalSpeed/2, {height: $(window).height(), ease:easeOut} );
					TweenMax.to(dummy, globalSpeed/2, {height:$(window).height() - 165, ease:easeOut});
				break;

			}
		}
	}


	function headerClick(e){
		if(page == 'store'){
			return true;
		} else {
			e.preventDefault();
			showStore();
			
		}
		
	}

	$('.continue__shopping').on('click', function(e){
			e.preventDefault();
			$('#drawer').hide();
			$('#store').show();
			$('#store-shopping-bag').removeClass('active');
		if(window.location.pathname != '/collections/all') { 
			window.location = $(this).attr('href');
		}
	})

	


	function footerNavClick(event){
		//---------[prevent page jumping around]
	    event.stopPropagation();
	    event.preventDefault();

	    introAnimation.progress(1, false);
	    headerOut();
	    topsection.on('mouseover', blackTintOver).on('mouseout', blackTintOut);

	    TweenMax.set(['.toggle-drawer', '.search-open'], {autoAlpha:0});
	    TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
        TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
        
        if($('#drawer').css('display') != 'none') {
			$('.toggle-drawer').trigger('click'); 
			$('#store-shopping-bag').removeClass('active');
		}

		//---------[animations]
    	TweenLite.to(footer, globalSpeed/2, {css:{top:headerH}, ease:easeOut, onComplete:function(){ 
    		if(!header.hasClass('fixed')){
				TweenMax.to(topsection, 0, {height:40, ease:easeOut});
				$('#top-section').addClass('fixed');
				$('#top-section').css('width', winW - scrollbarWidth);
				header.addClass('fixed');
				$('#wrapper').addClass('fix-fixed');
				header.css('width', winW-scrollbarWidth);
				//blacktint.on('mouseover', blackTintOver).on('mouseout', blackTintOut);
				//dummy.on('mouseover', blackTintOver).on('mouseout', blackTintOut);
			}

    		//$('#footer-section').css('overflow-y', 'scroll'); 

    	}});
		
		if(winW < 768)
		TweenLite.to($('#wrapper'), globalSpeed/2, {scrollTo: {y: 0, ease:easeOut}} );
		
		TweenMax.to(blacktint, globalSpeed/2, {autoAlpha: 1, ease:easeOut});
		TweenLite.to(topsection, globalSpeed/2, {height:40, ease:easeOut});
		
		if(!header.hasClass('fixed'))TweenLite.to(header, globalSpeed/2, {css:{top:0}, ease:easeOut});
		else TweenLite.to(header, globalSpeed/2, {css:{top:40}, ease:easeOut});

		if(topSectionHidden) TweenLite.to(header, globalSpeed/2, {css:{top:40}, ease:easeOut});
		
		TweenLite.to(dummy, globalSpeed/2, {height:40, ease:easeOut, onComplete:function(){
			TweenLite.to(header, 0, {css:{top:40}, ease:easeOut});
			if(!header.hasClass('fixed')){
				$('#top-section').addClass('fixed');
				$('#top-section').css('width', winW - scrollbarWidth);
				header.addClass('fixed');
				$('#wrapper').addClass('fix-fixed');
			}

		}});

		

		hitFooterTop = false;
		topSectionHidden = false;

		TweenLite.to($('#store-nav-container'), globalSpeed, {autoAlpha: 0} );
	    TweenLite.to($('#footer-section'), 0, {scrollTo: {y: $('#footer-container').scrollTop() + $(event.currentTarget.hash).position().top - 20}} );
	    

	    //disableContainerMousewheel();
	    
	    footer.find('nav a').removeClass('active');
	    $(event.currentTarget).addClass('active');



	    switch(page) {
	    	case "home":
	    		//$('#footer-section').find('.inner').css('padding-left', scrollbarWidth);
        		blacktint.off('mouseover', blackTintOver).off('mouseout', blackTintOut);
	    	break;

	    	case "store":
	    	break;
	    }


	    setPage("footer");
	    //disableContainerMousewheel();
	    

	    //$('#footer-section').find('.inner').css('padding-left', scrollbarWidth);

	}

	function hideMobileCart(){
		$('#store-shopping-bag').removeClass('open-bag');
		$('#store-shopping-bag').removeClass('openMenu');
		$('#store-shopping-bag').find('.cart-target').show();
		$('#store-shopping-bag').find('.close-drawer-icon').hide();

		//$('#drawer').hide();
	}
			
	function hideMobileSearch(){
		closeSearch();
	}

	function hideMobileMenu(){
		$('#main-menu').hide();
		$('#toggle-menu').removeClass('openMenu');
		$('#toggle-menu').find('.drawer-icon').show();
		$('#toggle-menu').find('.close-drawer-icon').hide();
		//$('.content_for_layout').hide();
	}


	$('#toggle-menu').on('click', function(){

		if($('#store-shopping-bag').hasClass('openMenu')){
			$('.toggle-drawer').trigger('click');
		}
		$('#store').show();
		$(this).toggleClass('openMenu');
		$(this).find('.drawer-icon').toggle();
		$(this).find('.close-drawer-icon').toggle();
		//$('.content_for_layout').show();

	});



	$('.toggle-drawer').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();

		if(!$('#store-shopping-bag .count').hasClass('empty')){
			$(this).addClass('active');
			if(winW < 768){
				
				if($('#toggle-menu').hasClass('openMenu')){
					$('#toggle-menu').trigger('click');
				}

				$('#store').toggle();
				$('#store-shopping-bag').removeClass('active');

				$('#store-shopping-bag').toggleClass('open-bag');
				$('#store-shopping-bag').toggleClass('openMenu');
				$(this).find('.cart-target').toggle();
				$(this).find('.close-drawer-icon').toggle();
				
			}
		}
	});

	




	function blackTintOver(e){

		e.stopPropagation();
		e.stopImmediatePropagation();

		//console.log('blackTintOver')

		if(!introFinished) {
			$('#photo-story h2').stop();
			//TweenLite.to("#photo-story h2", 0, {fontSize:"25px", height:"100px", top:"10px", lineHeight:"75px", textAlign:"center", letterSpacing:"1px"});
		}
			//TweenLite.set($('#a-day-observed-container'), {height:$(window).height() - (scroll + headerH), marginLeft:40 + scroll, marginRight:40 + scroll});

			//TweenLite.to("#a-day-observed-container", .1, {height:"90px", onUpdate:textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:3000, multiLine: false})});
			//TweenLite.to("#photo-story", globalSpeed, {width:winW, textAlign:"center", letterSpacing:"1px"});

			$('#top-section').prepend('<h2 class="preview">A Day Observed</h2>');

			TweenLite.to(header, .1, {css:{top:photoStoryMinH}, ease:easeNone});
			TweenLite.to(dummy, .1, {height:photoStoryMinH, ease:easeNone});
			TweenLite.to(topsection, .1, {height:photoStoryMinH, ease:easeNone});
			TweenLite.to(blacktint, .1, {autoAlpha:.6, ease:easeNone});

		if(getPage()!='footer'){
			//TweenLite.to($('#search-input'), .1, {y:50, ease:easeNone});
			TweenLite.to($('#search-results'), .1, {y:50, ease:easeNone});
			TweenLite.to($('#search-results-nav'), .1, {css:{top:50, ease:easeNone}});
		} else {
			TweenLite.to(footer, .1, {css:{top:headerH + 54}, ease:easeNone});
		}

		introAnimation.progress(1, false);
		headerOut();

		blacktint.css('cursor', 'pointer');
		dummy.css('cursor', 'pointer');
		return false;
	}

	function blackTintOut(e){
		e.stopPropagation();

		topSectionHidden = true; 

		var num = 40;

		//TweenLite.to("#a-day-observed-container", .1, {height:"40px", onUpdate:textFit($('.intro-fittext'), {alignVert: true, alignHoriz: true, multiLine: true, maxFontSize:30, multiLine: false})});

		TweenLite.to(header, .1, {css:{top:num}, ease:easeNone});
		TweenLite.to(dummy, .1, {height:num, ease:easeNone});
		TweenLite.to(topsection, .1, {height:num, ease:easeNone});
		TweenLite.to(blacktint, .1, {autoAlpha:1, ease:easeNone, onComplete:function(){ $('#top-section').find('.preview').remove(); }});


		
		if(getPage()!='footer'){
			//TweenLite.to($('#search-input'), .1, {y:0, ease:easeNone});
          	TweenLite.to($('#search-results'), .1, {y:0, ease:easeNone});
			TweenLite.to($('#search-results-nav'), .1, {css:{top:0, ease:easeNone}});
			
		} else {
			TweenLite.to(footer, .1, {css:{top:headerH}, ease:easeNone});
		}

		blacktint.css('cursor', 'auto');
		return false;
	}


	function overSearchPreview() {
		//console.log('over')
		$('#wrapper').disablescroll();
		
		if(!topSectionHidden){
			$('#search-results-nav').css('top', 50);
		} else {
			$('#search-results-nav').css('top', 0);
		}

		TweenMax.to($('#search-bg'), 2, {autoAlpha:.98, onComplete:function(){
			$('.search-open').addClass('over-active').trigger('click');
			$(".search-open").addClass('active')
		}});

		TweenMax.to($('.search-footer-bg'), 2, {autoAlpha:.98});

		$('#search-results-nav').show();
		
		$('.search-container').show();
		//$('#search-input').hide();
		$("#search-bg").show();
		$('.search-footer-bg').show();
		//$(".search-close").hide();
		//$('.search-query-results').hide();
	}

	function outSearchPreview () {

		if(!$('.search-open').hasClass('active')) {
			$('#wrapper').disablescroll('undo');
			$(".search-open").removeClass('over-active');
			TweenMax.to($('.search-footer-bg'), globalSpeed, {autoAlpha:0});
			TweenMax.to($('#search-bg'), globalSpeed, {autoAlpha:0, onComplete:function(){
				$('.search-container').hide();
				$("#search-bg").hide();
				$('.search-footer-bg').hide();
			}});
		}
	}


	function showSearch(e) {
		e.preventDefault();

		if(!$('.search-open').hasClass('active')) {
		
			$('.search-open').off("mouseover", overSearchPreview).off("mouseout", outSearchPreview);
			wrapper.disablescroll();
			disableContainerMousewheel();
			$("#search-results").show();
			$('#search-input').show();

			if(!$(".search-open").hasClass('over-active'))
			$(".search-open").addClass('active');

			TweenLite.to($('#search-results'), 0, {y:0});
			TweenMax.to($('#search-results'), globalSpeed/4, {autoAlpha:1});
			TweenMax.to($('#search-bg'), globalSpeed/4, {autoAlpha:.98});
			$('#search-results').css('top', 0);
			$('#search-results-nav').css('top', 0);
			$("#search-bg").show();
			$('#search-results-nav').show();
			$('.search-container').show();

			$('.search-query-results').hide();

			$("#search-results").addClass('topHidden').addClass('search-results-show');;
			if(winW > 768) {
				$('#search-input').css('top', 40);
			} else { 
				$('#search-input').css('top', 118);
				$('#wrapper').scrollTop(0);
			}
			
			if($("#search-results").hasClass('topHidden'))$("#search-results").removeClass('topHidden');

			var num = 40;
			
			TweenLite.to($('#search-input'), 0, {y:0, ease:easeOut});

			TweenLite.to(header, 0, {css:{top:num}, ease:easeOut});
			TweenLite.to(dummy, 0, {height:num, ease:easeOut});
			TweenLite.to(topsection, 0, {height:num, ease:easeOut});
			TweenLite.to(blacktint, 0, {autoAlpha:1, ease:easeOut});


			$('#search-foundwell-logo').hide();
			$('#search-foundwell-logo').css('height', winH - headerH - (photoStoryMinH*2)).css('top', 60);

			//pulse Foundwell logo then show results
			
			$('#search-input').val("");
			setTimeout(function(){ $('#search-input').focus(); }, 1000);
			$('#search-input')[0].focus();

			setPage('store');

			TweenLite.to(footer, 0, {css:{top:$(window).height()-footerH}, ease:easeOut});

			if($('body').attr('id') == 'archive'){
				TweenLite.to($('header'), globalSpeed/2, {css:{background:'#fafafa'}, ease:easeOut});
			}
		} else {
			$(".search-open").removeClass('over-active');
			closeSearch();
		}
	}

	function closeSearch() {
		$('.search-open').removeClass('active')

		if($('#store-shopping-bag').hasClass('openMenu')){
			$('.toggle-drawer').trigger('click');
		}
		if($('#toggle-menu').hasClass('openMenu')){
			$('#toggle-menu').trigger('click');
		}
		$('.search-open').on("mouseover", overSearchPreview).on("mouseout", outSearchPreview);
		wrapper.disablescroll('undo');
		enableContainerMousewheel();
		$('#search-foundwell-logo').hide();
		TweenMax.to($('#search-results'), 0, {autoAlpha:0});
		TweenMax.to($('#search-bg'), 0, {autoAlpha:0});
		TweenMax.to($('.search-footer-bg'), 0, {autoAlpha:0});
		//$('#search-results-nav .search-close').hide();
		//$('.search-close').hide();
      	
		$('.search-footer-bg').hide();
		$(".search-open").show();
		//$('#search-input' ).val(' ');
		/*TweenLite.to($('#search-results-nav .search-open'), 0, {autoAlpha:.5 , onComplete:function(){
			$('#search-results-nav').hide();
		}});*/

		if($('body').attr('id') == 'archive'){
			TweenLite.to($('header'), globalSpeed/2, {css:{background:'#bebebe'}, ease:easeOut});
		}
	}

	function showSearchQueries(item) {
      for(var i=0; i<item.length; i++){
        $('#search-query').append('<a href="'+item[i].url+'" class="row search-query-results"><h3>'+item[i].value+'</h3></a>');
      }
		//console.log('item ' + item);
        //console.log(item.length);
		//$('#search-query').append('<a href="'+item.url+'" class="row search-query-results"><h3>'+item.value+'</h3></a>');
	}



	function headerOver(e){
		e.stopImmediatePropagation();
            e.preventDefault();
		console.log('over');
		if(!$('header').hasClass('over')){
			if(getPage()!= 'store' && winW > 768) {
				TweenLite.to($('.in'), .1, {autoAlpha: 0, ease:easeNone});
				TweenLite.to($('.out'), .1, {autoAlpha: 1, ease:easeNone});
			} else {
				TweenLite.to($('.in'), .1, {autoAlpha: 1, ease:easeNone});
				TweenLite.to($('.out'), .1, {autoAlpha: 0, ease:easeNone});
			}
		}
		$('header').addClass('over');
	}

	function headerOut(){
		$('header').removeClass('over');
		if(getPage()!= 'store' && winW > 768) {
			TweenLite.to($('.in'), .1, {autoAlpha: 1, ease:easeNone});
			TweenLite.to($('.out'), .1, {autoAlpha: 0, ease:easeNone});
		} else {
			TweenLite.to($('.in'), .1, {autoAlpha: 1, ease:easeNone});
			TweenLite.to($('.out'), .1, {autoAlpha: 0, ease:easeNone});
		}
	}

	function archiveProductsOver(event){
		//console.log(event)

       // TweenLite.to($(this).find('img'), .4, {autoAlpha:.3});
        $(this).find('.archive-product-info').show();
        $(this).find('.archive-enquire').show();
    }

    function archiveProductsOut(event){
        //TweenLite.to($(this).find('img'), .4, {autoAlpha:1});
       // TweenLite.to($(this).find('img'), .4, {autoAlpha:1});
        $(this).find('.archive-product-info').hide();
        $(this).find('.archive-enquire').hide();
    }

    function archiveProductsClick(event){
    	if($(this).find('img').css('opacity') < 1){
    		TweenLite.to($(this).find('img'), .2, {autoAlpha:1});
    		$(this).find('.archive-product-info').hide();
        	$(this).find('.archive-enquire').hide();
    	} else {
    		TweenLite.to($(this).find('img'), .2, {autoAlpha:.3});
    		$(this).find('.archive-product-info').show();
        	$(this).find('.archive-enquire').show();
    	}
    	
        
    }



	// ------------------------------------------------------------------- [ DELEGATE FUNCTIONS ]
	// -----------------------------------------------------------------------------------------

	function switchPage(p) {

		p.preventDefault();
		showStore();


		switch(p.data.page) {

			case "header":

				if(storePage != "products") {
					//console.log('go')
					showProducts();
					storePage = "products";
				}
				
			break;

			case "home":
	
				if(storePage != "products") {
					
					showStore();
					storePage = "products";
				}
			break;

			case "all":
				//continueShopping()
		
				if(storePage != "products") {
					updateStoreNav($(this));
					
					showProducts();
					storePage = "products";
				}
			break;

			case "products":
	
				if(storePage != "pdp") {
					updateStoreNav($(this));
					
					showProductPage();
					storePage = "pdp";
            	}
			break;

			case "category":

				if(storePage != "category") {
					updateStoreNav($(this));
					
					showCategory();
					storePage = "category";
            	}
			break;

			case "collections":
				//console.log('collections')
				if(storePage != "collections") {
					updateStoreNav($(this));
					
					showcollections();
					storePage = "collections";
            	}
			break;

			case "product-page":
	
				if(storePage != "pdp") {
					updateStoreNav($(this));
					
					showProductPage();
					storePage = "pdp";
            	}
			break;

			case "get-product-page":
			//console.log('get product-page')
				closeSearch();
				if(storePage != "pdp") {
					updateStoreNav($(this));
					
					showProductPage();
					storePage = "pdp";
            	}
			break;

			case "archive":
		
				if(storePage != "archive") {
					updateStoreNav($(this));
		
					showArchive();
	            	storePage = "archive";
            	}
			break; 


			case "shopping_bag":
	
				if(storePage != "shopping_bag") {
					updateStoreNav('reset');
					
	            	showShoppingBag();
	            	storePage = "shopping_bag";
            	}
			break;

		}

	}



	// window resize
	function resize(){
		resizeGlobal();

		switch(page){

			case "store":
				resizeStore();
			break;

			case "home":
				resizeHome();
			break;

			case "footer":
				resizeFooter();
			break;

			default:

			break;
		}
		
	}

	var p;

	function resizeGlobal(){
		winW = $(window).width();
		winH = $(window).height();

		$('body').hide();

		$('#search-bg').css('height', winH);

		
		//console.log('HEIGHTTTTTT ' + $('#a-day-observed-container h2.desktop').css('font-size'))
		//TweenLite.set("#photo-story h5", {css:{top:(winH/2) - headerH + Number($('#a-day-observed-container h2.desktop').css('font-size'))}});

		
		

		$('footer nav').css('width', winW -scrollbarWidth);


		
		//$(".scene-block").css("top", winH/2 - $(".scene-block").height()/2 - 30);
		/*foundwellLogo.css("height", winH-(winH/4) - footerH).css("margin-top", (winH/2) - (foundwellLogo.height()/2) - 85).css("margin-left", -10);*/
		//$('.story-block').css('height', winH);
		//$('.story-block h3').css('height', winH);
		TweenMax.set(footer, 0, {y:-footerH});
        //TweenLite.set($(".slide"), {css:{height: winH}});

        //TweenLite.set("#photo-story h5", {css:{top:$(window).height()/2 + $("#photo-story h2").outerHeight()/2}});
        $('#wrapper').trigger('mouseWheel');

		if($('#top-section').hasClass('fixed'))
			$('#top-section').css('width', winW - scrollbarWidth);
		else
			$('#top-section').css('width', winW);
		header.css('width', winW - scrollbarWidth);

		if(page != 'footer')
		$('footer').css('top', winH - footerH);
		else
		$('footer').css('top', headerH);

		if (page == 'photostory')
		$('footer').css('top', winH + footerH);

		console.log('page = ' + page)

		
		//$('#footer-section').find('.inner').css('padding-left', scrollbarWidth);
		$('#footer-section').css('width', winW -scrollbarWidth);

		//$('#footer-section').css('left', scrollbarWidth);
		$('footer .inner').css('width', winW - (scrollbarWidth));

		$('#search-bg').css('width', winW - scrollbarWidth);
		//$('#inner-input').css('width', winW - scrollbarWidth);
		$('#top-section hr').css('margin-right', (winW * .03) + scrollbarWidth);


		$('.top-story').css('height', winH - headerH + 20);
		    	//top section points
		$('.top-story').each(function(index){
			
			points.push( {point: $(window).width() / (index + 1), 
						  width: $(window).width()/totalStories,
						  xPos: index * $(window).width()/totalStories} )

			
		});

		//footer 
		footer.css('height', winH).css('width', winW -scrollbarWidth);
		$('#footer-contact-container').css('height', (footer.height()) - 100)

		//height	//photostories
		$('.pin-container').css('height', $(window).height() * 4).css('width', winW - scrollbarWidth);
	    $('.bg-img').css('height', $(window).height()).css('width', winW - scrollbarWidth);
	    $('.pin').css('height', $(window).height());

	    $('.main-wrapper').css('height', $(window).height());

	    $('.first-pin-container').css('height', $(window).height());
	    $('.last-pin-container').css('height', $(window).height() * 2);


	    // mobile
	    if(winW < 1024) {
	    	//$('.image-holder').find('img').attr('src', $('.image-holder').find('img').attr('src').split('1024x1024').join('grande'));
	    } else {
	    	//$('.image-holder').find('img').attr('src', $('.image-holder').find('img').attr('src').split('grande').join('1024x1024'));
	    }
	    if(winW > 768) {
	    	headerH = 145;
	    	$('#a-day-observed-container').css('height', (winH/2) - (headerH/2)).css('width', winW - 80).css('left', 30);
			$('#a-day-observed-container').fitText(1.1, { minFontSize: '40px' });
			$('#a-day-observed-container h2').css('top', (winH/2) - headerH - ($('#a-day-observed-container h2').height()/2));

			if(p) {
				console.log(p)
				$( "#photo-stories" ).prepend(p);
    			//p = null;
    		}
    		//$( "#photo-stories" ).find('.parallax-scroller').css('visibility', 'visible').css('opacity', 1);
			//$('#photo-stories').prepend(p)

	    	$('#search-input').css('top', 118).css('width', winW - 65);
	    	var max_margin = 575;
	    	var new_margin = ((winW - 65)/2) < 575 ? ((winW - 65)/2) : 575;
	    	$('#search-results').css('width', winW - 65).css('margin-left', -new_margin)

	    	$('#photo-story .subtext').css('height', (winH/2) - (headerH/2)).css('top', (winH/2) - (headerH /2)+ 40);

	    	$('#toggle-menu').removeClass('openMenu');
			$('#store-shopping-bag').removeClass('open-bag');
			$('#store-shopping-bag').find('.close-drawer-icon').hide();
			$('#store-shopping-bag').find('.cart-target').show();
			$('#search-input').css('top', 40);
          	$('.search-bg').css('width', winW - scrollbarWidth);
          	$('#inner-input .search-open').css('right', 22 + scrollbarWidth/2 + 'px');
  			$('#inner-input').css('margin-left', -scrollbarWidth/2);
			$('#a-day-observed-container h2.desktop').css('visibility', 'visible').css('opacity', 1)
			$('.search-close').css('right', scrollbarWidth + 22);
			$('#store').show();
			$('#photo-story h5').css('margin-top', $('a-day-observed-container').css('font-size') + 40);
			if(!pinEnabled) {
				//console.log('zebra pushed')
				pinEnabled = true;
				for (var i=0; i < $('.pin-container').length; i++) {
        			zebra.push( new $.Zebra_Pin($('#pin'+i), { contain: true }), wrapper = $('.pin'+i+'-container') );
    			}
			}
	    } else {
	    	headerH = 115;

	    	//p = $('.parallax-scroller').detach();
	    	//$( "#photo-stories" ).find('.parallax-scroller').css('visibility', 'hidden').css('opacity', 0);

	    	if($('#drawer').css('display') != 'none') {
	    		$('#store-shopping-bag').addClass('open-bag');
				$('#store-shopping-bag').find('.close-drawer-icon').show();
				$('#store-shopping-bag').find('.cart-target').hide();
				$('#store').hide();
	    	}

	    	$('#a-day-observed-container').css('height', (winH/2) - (headerH/2)).css('width', winW - 80).css('left', 30);
			$('#a-day-observed-container').fitText(1.1, { minFontSize: '40px' });
			$('#a-day-observed-container h2').css('top', (winH/2) - headerH - ($('#a-day-observed-container h2').height()));

	    	$('#photo-story .subtext').css('height', (winH/2) - (headerH/2)).css('top', (winH/2) - (headerH /2)+ 20);
	    	$('#photo-story h5').css('margin-top', $('a-day-observed-container').css('font-size') + 0);

	    	$('#search-input').css('top', 118).css('width', winW - 40);

	    	//$('.slide').css('height', winH * 2);
	    	//$('.slide.first').css('height', winH);
	    	//$('.slide.last').css('height', winH);

	    	$('#a-day-observed-container').fitText(.8, { minFontSize: '40px' });
	    	$('#toggle-menu').css('margin-right', scrollbarWidth + 25);
	    	$('#search-input').css('top', 113); 
	    	$('#a-day-observed-container h2.mobile').css('margin-top', -20);
	    	$('#a-day-observed-container').css('left', 0).css('width', '100%'); 
	    }


	    


	  
		
	    $('body').show();
	  
			
	}

	function resizeStore(){

	
	}

	function resizeHome(){
		//alert('resize')
		TweenMax.set(dummy, {height:$(window).height()-headerH - 20});
		
		TweenMax.set($('.black-tint-intro'), {height:$(window).height()-headerH});
		TweenMax.set($('#top-section'), {height:$(window).height()-headerH-20});
		$('footer').css('top', $(window).height() - footerH);
		//footer.css('top', $(window).height());
	}

	function resizeFooter(){
		
		//$('footer').css('top', $(window).height() - 40);
		//TweenLite.to($('footer'), globalSpeed, {y: -$(window).height() + headerH + photoStoryMinH, force3D:true});
	}


	var $img = $('.preload-images img'),
        totalImg = $img.length;


    
    var waitImgDone = function() {
        totalImg--;
        console.log(totalImg)
        if (totalImg == 1) {
        	intro('play');
			if($('body').hasClass('template-product') ||
	   		$('body').hasClass('template-collection')) {
				introAnimation.progress(1, false);
				introFinished = true;
			}
			//setPage("home");
        }
    };
    
    $('.preload-images img').each(function() {
        $(this)
            .load(waitImgDone)
            .error(waitImgDone);
    });

	//intro();
	//resize();

	/*
	if($('body').hasClass('template-product') ||
	   $('body').hasClass('template-collection') ||
	   $('body').hasClass('template-cart') ||
	   (history.pushState && window.location.hash == "#store")) {
	   	history.pushState(null, null, '#store');
		loadStore();
	} else if (history.pushState && window.location.hash == "#home") {
		console.log('load home')
	}
	*/

	function init() {
		var pageLoad = "home";
		outSearchPreview();

		$('.slide blockquote').widowFix();
 
		/*
		if((history.pushState && window.location.hash == "#store")) {
		   	history.pushState(null, null, '#store');
			loadStore();
		} else if (history.pushState && window.location.hash == "#home") {
			console.log('load home')
		} else {
			console.log('load home')
		}*/

		$('.img-container').imagefill(); 

		WebFont.load({
		    custom: {
		      families: ['sigmaregular', 'csm', 'wind', 'windcond', 'sigmabold']
		    }
		});

		$('footer').find('img').attr('data-pin-nopin', 'true');

		if($('body').hasClass('template-product') ||
		   $('body').hasClass('template-collection') ||
		   $('body').hasClass('template-cart') ||
		   (history.pushState && window.location.hash == "#store")) {
		   	pageLoad = "store";
		}else {

			pageLoad = "home";
		}

		switch(pageLoad) {
			case "home":
			break;
			case "store":
			history.pushState(null, null, '#store');
			loadStore();
			break;
			case "photostory":
			break;
			case "footer":
			break;
			default:
			pageLoad = "home";
			break;
		}


		$('#search-input' ).val('Search Term');

		if($('body').attr('id')=='archive'){
			$('.archive-product-info').widowFix();
		if($(dummy).height() < winH - 200){
			TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
			TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"#bebebe", ease:easeOut,});
		} else {
			TweenLite.to($("header"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
			TweenLite.to($("#store"), globalSpeed/2, {backgroundColor:"rgb(250, 250, 250)", ease:easeOut,});
		}
		}
      
      	if( $('#item-dimensions').length){
          /*
          $('#item-dimensions dd').each(function(){
            var str = $(this).html();
            str = str.split('"').join('');
            
            var cent = (Number(str) * 2.54).toFixed(1);
            
            str = str + ' inches (' + cent + 'cm)';
            if(cent != 0.0)
            $(this).html(str);
            else
            $('#item-dimensions').remove();  
          });
          */
        }

		var mark_num = String(Math.round(Math.random()*2)+ 1);
		var mark = '<div class="btm-mark"><img src="http://cdn.shopify.com/s/files/1/0689/2617/t/2/assets/mark-'+mark_num+'.svg" /></div>';
		$('#store').append(mark)

		var autothumb;
      
        function split( val ) {
        	return val.split( /,\s*/ );
        }
        function extractLast( term ) {
			return split( term ).pop();
        }

		/* SEARCH AUTOCOMPLETE */
		var cache = {};
		
		
		  // Current Ajax request.
		  var currentAjaxRequest = null;
		  // Grabbing all search forms on the page, and adding a .search-results list to each.
		  var searchForms = $('form[action="/search"]').each(function() {
		    // Grabbing text input.
		    var input = $(this).find('input[name="q"]');

		    // Listening to keyup and change on the text field within these search forms.
		    input.attr('autocomplete', 'off').bind('keyup change', function(e) {
				console.log(e);
		      // What's the search term?
		      var term = $(this).val();
			  
			  if(e.keyCode == 32 && $(this).val() != '' && $(this).val().substr($(this).val().length - 1) != ' ') {
				  $(this).val(term + ' ');
				  term = $(this).val();
			  }
			  
		      // What's the search form?
		      var form = $(this).closest('form');
		      // What's the search URL?
		      var searchURL = 'https://foundwell.com/search?type=product&q=' + term;
		      // What's the search results list?
			  
			  console.log('term ' + term);
			  

		      // If that's a new term and it contains at least 3 characters.
		      if (term.length > 3 && term != $(this).attr('data-old-term')) {
		        // Saving old query.
		        $(this).attr('data-old-term', term);
		        // Killing any Ajax request that's currently being processed.
                console.log('currentAjaxRequest:');
                console.log(currentAjaxRequest);
		        if (currentAjaxRequest != null) currentAjaxRequest.abort();
		        // Pulling results.
		        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
                  console.log('initializing search ajax request');
		          // Reset results.
		          //resultsList.empty();
		          // If we have no results.
		          if(data.results_count == 0) {
		            // resultsList.html('<li><span class="title">No results.</span></li>');
		            // resultsList.fadeIn(200);
		            //resultsList.hide();
		          } else {
		            // If we have results.
					  console.log(data);
					  if (data.length) {
						//cache[request.term] = data;
					  }
					  $('#search-query').html('');
					  //response(data);
                      showSearchQueries(data);
					  /*
		            $.each(data.results, function(index, item) {
		              var link = $('<a></a>').attr('href', item.url);
		              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
		              link.append('<span class="title">' + item.title + '</span>');
		              link.wrap('<li></li>');
		              resultsList.append(link.parent());
		            });
		            // The Ajax request will return at the most 10 results.
		            // If there are more than 10, let's link to the search results page.
		            if(data.results_count > 10) {
		              resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
		            }
		            resultsList.fadeIn(200);
					  */
		          }        
		        });
		      }
		    });
		  });
		  // Clicking outside makes the results disappear.
		  $('body').bind('click', function(){
		    $('.search-results').hide();
		  });
	
		
		
		
		/*
		$( '#search-input' ).autocomplete({
			
			source: function( request, response ) {
              	
				if (request.term in cache) {
					response(cache[request.term]);
                  	$('#search-query').html('');
                  	showSearchQueries(cache[request.term])
					return;
				}
              
				$.ajax({
					url: "http://foundwell.com/search", 
					data: {
						q: "*" + escape(request.term) + "*",
						type: "product",
						view: "json",
					},
					dataType: "json",
                  	multiple: true,
        			multipleSeparator: " ", 
					success: function( data ) {
                      
						if (data.length) {
							cache[request.term] = data;
						}
						$('#search-query').html('');
						response(data);
                        showSearchQueries(data);
					}
				});
                
                
			},
			minLength: 2,
			select: function( event, ui ) {
				window.location = ui.item.url;
			},
		});
		*/
        
     
		
      	
	     $('#search-input' ).focus(function(){
		 if ($(this).val() == "Search Term"){
		   $(this).val("");
		 }
		});
		
		$('#search-input' ).blur(function(){
		 if ($(this).val() == ""){
		   setTimeout(function(){ $(this).val("Search Term"); }, 500);
		 }
		});
        
        

		$('[placeholder]').focus(function() {
	        var input = $(this);
	        if (input.val() == input.attr('placeholder')) {
	            input.val('');
	            input.removeClass('placeholder');
	        }
	    }).blur(function() {
	        var input = $(this);
	        if (input.val() == '' || input.val() == input.attr('placeholder')) {
	            input.addClass('placeholder');
	            input.val(input.attr('placeholder'));
	        }
	    }).blur();
	    $('[placeholder]').parents('form').submit(function() {
	        $(this).find('[placeholder]').each(function() {
	            var input = $(this);
	            if (input.val() == input.attr('placeholder')) {
	                input.val('');
	            }
	        })
	    });



	}

	
	intro('init');
	resize();
	init();



	if(winW > 768) {
		//console.log('zebra pushed')
		pinEnabled = true;
		for (var i=0; i < $('.pin-container').length; i++) {
        	zebra.push( new $.Zebra_Pin($('#pin'+i), { contain: true }), wrapper = $('.pin'+i+'-container') );
    	}
	} else {
		pinEnabled = false;
	}
















	
}); // end document ready

function convert_str(str)
{
	
  str = str.replace(/&/g, "&amp;");
  str = str.replace(/>/g, "&gt;");
  str = str.replace(/</g, "&lt;");
  str = str.replace(/"/g, "&quot;");
  str = str.replace(/'/g, "&#039;");
  return str;
}

	// ------------------------------------------------------------------- [ EXT FUNCTIONS ]
	// -------------------------------------------------------------------------------------

// get Scrollbar width Tested 2012-03-28 on Windows 7 in latest FF, Chrome, IE & Safari and 100% working.
$.scrollbarWidth=function(){var a,b,c;if(c===undefined){a=$('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body');b=a.children();c=b.innerWidth()-b.height(99).innerWidth();a.remove()}return c};

